import sum from 'lodash/sum'

const LAMBDA_POWER_MULTIPLIERS_CYL: Record<number, number> = {
  0: 1.001,
  1: -0.014195,
  2: 0.2909,
  3: -0.09642,
  4: 0.02089,
  5: -0.003054,
  6: 2.957e-4,
  7: -1.8462e-5,
  8: 7.1553e-7,
  9: -1.5631e-8,
  10: 1.4656e-10,
}
export function computeMtCylindrical(lambda: number): number {
  const values = Object.entries(LAMBDA_POWER_MULTIPLIERS_CYL)
    .map(([key, value]) => [parseInt(key), value] as [number, number])
    .map(
      ([power, multiplier]) =>
        multiplier * Math.pow(Math.min(lambda, 20), power)
    )
  return sum(values)
}
